export const enum CHECK_IN_TRIP_BY {
  CONFIRMATION_NUMBER = 'Confirmation Number',
  CREDIT_CARD_NUMBER = 'Credit Card Number',
  TICKET_NUMBER = 'Ticket Number',
  SKYMILES_NUMBER = 'SkyMiles Number'
}

export const enum FORM_FIELD_NAMES {
  FIND_TRIP_BY = 'findTripBy',
  FIND_TRIP_BY_VALUE = 'findTripByValue',
  LAST_NAME = 'lastName',
  ORIGIN_AIRPORT_CODE = 'originAirportCode'
}
export const enum FORM_FIELD_IDS {
  FIND_TRIP_BY = 'dropdownCheckIn',
  FIND_TRIP_BY_VALUE = 'input-trip-by-value'
}
export const enum DEFAULTS {
  EMPTY_STRING = '',
  CONFIRMATION_NUMBER = 'Confirmation Number  '
}

export const FORM_TO_SESSION_MAPPING = [
  'checkinSearchType',
  'checkinETicketNumber',
  'checkinSkymilesNumber',
  'checkinCreditcardNumber',
  'checkinLastName',
  'checkinConfirmationNumber',
  'checkinDepartureAirport'
];

export const SEARCH_TYPE = 'confirmationInput';

export const CHECKIN_SEARCH_TYPE_MAP: Record<string, string> = {
  'Confirmation Number': 'confirmationInput',
  'Ticket Number': 'eticketInput',
  'SkyMiles Number': 'skymilesInput',
  'Credit Card Number': 'creditCardInput'
};
